"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Warning = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Warning, _Component);

  var _super = _createSuper(Warning);

  function Warning() {
    (0, _classCallCheck2["default"])(this, Warning);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Warning, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base["default"], (0, _extends2["default"])({
        viewBox: "0 0 64 64"
      }, this.props), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M0.349,49h49.302L25,1.842L0.349,49z M3.651,47L25,6.159L46.349,47H3.651z"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        height: "18",
        width: "2",
        x: "24",
        y: "18"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        height: "3",
        width: "2",
        x: "24",
        y: "39"
      }));
    }
  }]);
  return Warning;
}(_react.Component);

exports["default"] = Warning;
(0, _defineProperty2["default"])(Warning, "defaultProps", {
  height: '16px',
  predefinedClassName: 'data-ex-icons-warning',
  stroke: '#FFF'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vaWNvbnMvd2FybmluZy50c3giXSwibmFtZXMiOlsiV2FybmluZyIsInByb3BzIiwiQ29tcG9uZW50IiwiaGVpZ2h0IiwicHJlZGVmaW5lZENsYXNzTmFtZSIsInN0cm9rZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7SUFFcUJBLE87Ozs7Ozs7Ozs7OztXQU9uQixrQkFBUztBQUNQLDBCQUNFLGdDQUFDLGdCQUFEO0FBQU0sUUFBQSxPQUFPLEVBQUM7QUFBZCxTQUE4QixLQUFLQyxLQUFuQyxnQkFDRTtBQUFNLFFBQUEsQ0FBQyxFQUFDO0FBQVIsUUFERixlQUVFO0FBQU0sUUFBQSxNQUFNLEVBQUMsSUFBYjtBQUFrQixRQUFBLEtBQUssRUFBQyxHQUF4QjtBQUE0QixRQUFBLENBQUMsRUFBQyxJQUE5QjtBQUFtQyxRQUFBLENBQUMsRUFBQztBQUFyQyxRQUZGLGVBR0U7QUFBTSxRQUFBLE1BQU0sRUFBQyxHQUFiO0FBQWlCLFFBQUEsS0FBSyxFQUFDLEdBQXZCO0FBQTJCLFFBQUEsQ0FBQyxFQUFDLElBQTdCO0FBQWtDLFFBQUEsQ0FBQyxFQUFDO0FBQXBDLFFBSEYsQ0FERjtBQU9EOzs7RUFma0NDLGdCOzs7aUNBQWhCRixPLGtCQUNHO0FBQ3BCRyxFQUFBQSxNQUFNLEVBQUUsTUFEWTtBQUVwQkMsRUFBQUEsbUJBQW1CLEVBQUUsdUJBRkQ7QUFHcEJDLEVBQUFBLE1BQU0sRUFBRTtBQUhZLEMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTUERYLUxpY2Vuc2UtSWRlbnRpZmllcjogTUlUXG4vLyBDb3B5cmlnaHQgY29udHJpYnV0b3JzIHRvIHRoZSBrZXBsZXIuZ2wgcHJvamVjdFxuXG5pbXBvcnQgUmVhY3QsIHtDb21wb25lbnR9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBCYXNlLCB7QmFzZVByb3BzfSBmcm9tICcuL2Jhc2UnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBXYXJuaW5nIGV4dGVuZHMgQ29tcG9uZW50PFBhcnRpYWw8QmFzZVByb3BzPj4ge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGhlaWdodDogJzE2cHgnLFxuICAgIHByZWRlZmluZWRDbGFzc05hbWU6ICdkYXRhLWV4LWljb25zLXdhcm5pbmcnLFxuICAgIHN0cm9rZTogJyNGRkYnXG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8QmFzZSB2aWV3Qm94PVwiMCAwIDY0IDY0XCIgey4uLnRoaXMucHJvcHN9PlxuICAgICAgICA8cGF0aCBkPVwiTTAuMzQ5LDQ5aDQ5LjMwMkwyNSwxLjg0MkwwLjM0OSw0OXogTTMuNjUxLDQ3TDI1LDYuMTU5TDQ2LjM0OSw0N0gzLjY1MXpcIiAvPlxuICAgICAgICA8cmVjdCBoZWlnaHQ9XCIxOFwiIHdpZHRoPVwiMlwiIHg9XCIyNFwiIHk9XCIxOFwiIC8+XG4gICAgICAgIDxyZWN0IGhlaWdodD1cIjNcIiB3aWR0aD1cIjJcIiB4PVwiMjRcIiB5PVwiMzlcIiAvPlxuICAgICAgPC9CYXNlPlxuICAgICk7XG4gIH1cbn1cbiJdfQ==